import { Pipe, PipeTransform, inject } from '@angular/core';
import {map} from 'rxjs/operators';
import {BdPermissionsCompanyService} from './company.service';
import {firstValueFrom} from 'rxjs';

@Pipe({
  name: 'company',
  standalone: true
})
export class BdPermissionCompanyPipe implements PipeTransform {
  private _companyService = inject(BdPermissionsCompanyService);


  transform(value: string): Promise<string> {
    return firstValueFrom(
      this._companyService.getById(value)
        .pipe(
          map(company => company.name)
        )
    );
  }

}
